module.exports = __webpack_public_path__ + "static/media/Gluten.55684a6f.png";